module.exports = __webpack_public_path__ + "media/images/mission_bg_2-abbc69299dea0b5e500531e64f74da1e.svg";